import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Field, reduxForm, reset } from 'redux-form';

import Svg from './Svg';


const PleaseWait = () => (
<div className="text-center">
	<Svg iconName="icon-cloud" />
	<p>Please wait while we create your profile...</p>
</div>
)

class FinishRegistartionForm extends Component {
	constructor(props) {
		super(props)
	}

	componentDidMount() {
		this.buttonElement.click()
	}
	render() {
		const { handleSubmit, pristine, previousPage, submitting, enableButton } = this.props
		console.log(this.props);
		return (
			<form onSubmit={handleSubmit} className="registartion-finish-form">

				<section className="section gray-bg">
					<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">

					 <PleaseWait />
				
					</div>
					</div>
				</section>

				<section className="section registration-action-buttons">
					<div className="grid-x align-center">
						<div className="small-12 cell text-center">
						<button 
							 	ref={input => this.buttonElement = input}
								className="button primary next hide" 
								type="submit"
								disabled={enableButton || pristine || submitting} >Submit</button>

							<button 
								className="button primary next" 
								disabled={enableButton || pristine || submitting} >Submit</button>
						</div>
					</div>
				</section>
			</form>
	  	)
	}
}

export default reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  onSubmitSuccess: (result, dispatch) => dispatch(reset('artistRegistrationWizard'))
})(FinishRegistartionForm)


// WEBPACK FOOTER //
// ./src/components/FinishRegistrationForm.js